import { useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../../recoil/auth";
import { insetState } from "../../../../../recoil/inset";
import {
  HomeHeaderWrapper,
  HomeHeaderLeft,
  HomeHeaderRight,
} from "../../styles";
import HomeHeaderSkeleton from "./skeleton";

interface HomeHeaderProps {
  loading?: boolean;
}

const HomeHeader = ({ loading = false }: HomeHeaderProps) => {
  const history = useHistory();
  const user = useRecoilValue(userState);
  const inset = useRecoilValue(insetState);

  const isLoggedIn = !!user;

  const getIconPath = (iconName: string) =>
    `image-web/home/${iconName}${isLoggedIn ? "" : "-black"}.svg`;

  const handleLoginClick = () => {
    if (!isLoggedIn) {
      history.push("/login");
    }
  };

  const handleChatClick = () => history.push("/openChat");

  const handleCouponClick = () => history.push("/mypage?menu=coupon");

  const handleAlarmClick = () => {
    const targetPath = isLoggedIn ? "/alarm" : "/login";
    history.push(targetPath);
  };

  // 로딩 중일 때 스켈레톤 표시
  if (loading) {
    return <HomeHeaderSkeleton />;
  }

  return (
    <HomeHeaderWrapper isLogin={isLoggedIn} inset={inset}>
      <HomeHeaderLeft onClick={handleLoginClick}>
        <div className={isLoggedIn ? "name" : "login"}>
          {isLoggedIn ? `${user.nickname}님` : "로그인을 해주세요"}
        </div>
        {isLoggedIn && <div className="welcome">환영합니다!</div>}
      </HomeHeaderLeft>

      <HomeHeaderRight>
        <img
          src={getIconPath("chat")}
          alt="오픈챗팅"
          onClick={handleChatClick}
        />
        <img
          src={getIconPath("coupon")}
          alt="쿠폰"
          onClick={handleCouponClick}
        />
        <div className="alarm" onClick={handleAlarmClick}>
          {isLoggedIn && user.hasUnreadNotification && (
            <img
              className="icon"
              src="image-web/home/alarm-red.svg"
              alt="알람"
            />
          )}
          <img src={getIconPath("alarm")} alt="알람" />
        </div>
      </HomeHeaderRight>
    </HomeHeaderWrapper>
  );
};

export default HomeHeader;
